/* eslint react/jsx-props-no-spreading: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ActivityIndicator,
} from 'react-native';
import { Button } from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import AORTypes from '../../types';
import { AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import { AppSyncClientAudit } from '../../backends/AppSyncClientAudit';
import GetApp from '../../q/GetApp';
import GetPendingApps from '../../q/audit/GetPendingApps';
import AppDecline from '../../q/audit/AppDecline';
import App from '../../modules/data/App';
import AppBadge from '../../components/apps/AppBadge';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class Decline extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleAction = this.handleAction.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'AppDecline';
  }

  handleCancel() {
    const { app, history } = this.props;

    history.push(`/ai-agent/online/${app.uuid}`);
  }

  handleAction() {
    const { action, history } = this.props;

    action().then(() => {
      history.push('/pendingtours');
    });
  }

  render() {
    const { app: data } = this.props;

    if (!data) {
      return (
        <View
          style={{
            backgroundColor: 'white',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    const app = App.createFromData(data);

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          <View
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <AppBadge data={app.data} />
          </View>
          <View style={styles.form.containerButtons}>
            <Button
              title={translate('button_cancel')}
              containerStyle={styles.button.secondaryContainer}
              buttonStyle={styles.button.secondary}
              disabledStyle={styles.button.secondaryDisabled}
              titleStyle={styles.button.secondaryTitle}
              disabledTitleStyle={styles.button.secondaryTitleDisabled}
              onPress={this.handleCancel}
            />
            <Button
              title="Decline"
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={this.handleAction}
            />
          </View>
        </View>
      </View>
    );
  }
}

Decline.defaultProps = {
  app: null,
};

Decline.propTypes = {
  app: AORTypes.App,
  history: ReactRouterPropTypes.history.isRequired,
  action: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetApp, {
    props: (props) => {
      console.log('graphql returned: GetApp: ');
      console.log(props.data);

      return {
        app: props.data.getApp,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.uuid,
      },
      client: AppSyncClientUnauthenticated,
      fetchPolicy: 'cache-and-network',
    }),
    client: AppSyncClientUnauthenticated,
  }),
  graphql(AppDecline, {
    props: (props) => ({
      action: () => {
        console.log('props');
        console.log(props);

        return props.mutate({
          variables: {
            uuid: props.ownProps.uuid,
          },
        });
      },
    }),
    options: (_props) => ({
      refetchQueries: [{
        query: GetPendingApps,
        client: AppSyncClientAudit,
      }],
      client: AppSyncClientAudit,
    }),
  })
)(Decline);
